// Public Lexi stays off until the owner explicitly requests re-enablement.
// The backend independently enforces feature_flags.public_lexi_enabled=false.
export const LEXI_ENABLED = false;
export const PUBLIC_SIGN_IN_VISIBLE = false;
